let subscribers = {};
let pendingEvents = {}; // buffer for events published before any subscriber

const PENDING_EVENT_TTL = 10000; // replay within 10 seconds of publish

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  // If an event was published before this subscriber registered, replay it now
  if (pendingEvents[eventName]) {
    const { data, timestamp } = pendingEvents[eventName];
    if (Date.now() - timestamp < PENDING_EVENT_TTL) {
      callback(data);
    } else {
      delete pendingEvents[eventName];
    }
  }

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName] && subscribers[eventName].length > 0) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data));
    return Promise.all(promises);
  } else {
    // No subscribers yet — buffer the most recent event so late subscribers get it
    pendingEvents[eventName] = { data, timestamp: Date.now() };
    return Promise.resolve();
  }
}
